import {
  Component,
  Input,
  ViewEncapsulation,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  OnChanges,
  HostListener,
  OnInit
} from '@angular/core';
import { TrackingPageModel } from '../tracking-page.model';
import { BehaviorSubject } from 'rxjs';
import { TrackingPageCoreService } from '../tracking-page-core.service';
import { isEqual } from 'lodash';

@Component({
  selector: 'app-tracking-page',
  templateUrl: './tracking-page.component.html',
  styleUrls: ['./tracking-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrackingPageComponent implements OnInit, OnChanges {
  @Input() numbers: any;
  @Input() checkpoints: any;
  @Input() sidebarProductItems = [];
  @Input() mainProductItems = [];
  @Input() showDetails: any;
  @Input() showDetailsLoading: any;
  @Input() sideBarItems: any;
  @Input() sideBarItemsOpened: any;
  @Input() showMoreSideBarItems: any;
  @Input() moreValues: any;
  @Input() loadMoreVisible: boolean;
  @Input() selectedItem: any;
  @Input() mode: any;
  @Input() preventNavigation;
  @Input() trackingPage: TrackingPageModel;
  @Input() backgroundImage: string;
  @Input() logo: string;
  @Input() disableScrollUpdate: boolean;
  @Input() visualBuilder: boolean;
  @Input() reviewEnabled: boolean;
  @Input() loadMoreTrackingNumbers: boolean;
  @Input() moreTrackingNumberValues: number;
  @Input() selectedVisualBuilderId: any;
  @Output() selectTrackingNumber = new EventEmitter();
  @Output() toggleSideBarItemOpen = new EventEmitter();
  @Output() toggleDetails = new EventEmitter();
  @Output() showMore = new EventEmitter();
  @Output() onSearchClick = new EventEmitter();
  @Output() submitReview = new EventEmitter();
  @Output() selectBlock = new EventEmitter();
  @Output() triggerLoadMoreTrackingNumbers = new EventEmitter();
  @Output() changeLanguage = new EventEmitter();

  @ViewChild('containerBlock', { read: ElementRef })
  containerBlock: ElementRef;
  @ViewChild('blocksWrapper', { read: ElementRef })
  blocksWrapper: ElementRef;
  @ViewChild('checkingSection', { read: ElementRef })
  checkingSection: ElementRef;
  @ViewChild('sidebarBlock', { read: ElementRef })
  sidebarBlock: ElementRef;

  sidebarOpened$ = new BehaviorSubject(false);
  isMobile: boolean;

  constructor(private trackingPageCoreService: TrackingPageCoreService) {}

  get backgroundStyles() {
    return this.trackingPageCoreService.getTrackingPageBackground(
      this.trackingPage
    );
  }

  get orderCardStyles() {
    const { borderRadius, borderWidth, borderColor, backgroundColor, shadow } =
      this.trackingPage.orderCard;
    return {
      'borderRadius.px': borderRadius,
      'borderWidth.px': borderWidth,
      borderColor,
      backgroundColor,
      boxShadow: shadow
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobile =
      this.mode === 'mobile' || window.matchMedia('(max-width: 992px)').matches;
  }

  ngOnInit() {
    this.onResize();
  }

  toggleSidebarOpened() {
    if (this.visualBuilder) {
      if (!this.sidebarOpened$.value) {
        const top = this.checkingSection.nativeElement.scrollTop;
        this.checkingSection.nativeElement.style.overflow = 'hidden';
        this.sidebarBlock.nativeElement.style.height = '100vh';
        this.sidebarBlock.nativeElement.style.top = `${top}px`;
        this.sidebarBlock.nativeElement.style.zIndex = 1000;
      } else {
        this.checkingSection.nativeElement.style.overflowY = 'auto';
        if (this.sidebarBlock) {
          this.sidebarBlock.nativeElement.style.zIndex = -1;
          this.sidebarBlock.nativeElement.style.height = 'auto';
        }
      }
    }
    this.sidebarOpened$.next(!this.sidebarOpened$.value);
  }

  ngOnChanges(changes) {
    if (changes.selectedItem && changes.selectedItem.currentValue) {
      this.scrollToSelectedNumber(changes.selectedItem.currentValue);
    }
    this.onResize();
  }

  scrollToSelectedNumber(id) {
    const trackingNumber = document.getElementById(id);
    if (trackingNumber) {
      trackingNumber.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  showFeedbackModal({ id, data, number }) {
    this.trackingPageCoreService.showFeedbackModal(
      { data, number },
      (response) => {
        this.submitReview.emit({ data: response, id });
      }
    );
  }

  onClick({ target }) {
    if (
      (this.checkingSection &&
        isEqual(target, this.checkingSection.nativeElement)) ||
      (this.containerBlock &&
        isEqual(target, this.containerBlock.nativeElement)) ||
      (this.blocksWrapper &&
        isEqual(target, this.blocksWrapper.nativeElement)) ||
      (this.sidebarBlock && isEqual(target, this.sidebarBlock.nativeElement))
    ) {
      this.selectBlock.emit('background');
    }
  }

  toggleCheckpoints(event, orderId) {
    this.toggleDetails.emit({ ...event, orderId });
  }
}
